import { render } from "./VirementList.vue?vue&type=template&id=a57efb2e"
import script from "./VirementList.vue?vue&type=script&lang=js"
export * from "./VirementList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__